import { ReferenciaMaestrasFosfec } from "../../../../interfaces/ReferenciaMaestrasFosfec";

function sectionFieldsDdlAdapter (field: any, maestrasFosfec: ReferenciaMaestrasFosfec ) {

    if(field.name === "compensationFund"){
       field.options = [
             {
                   id: "undefined",
                   label: "Selecciona",
                   value: "",
                },
                ...maestrasFosfec.compensationFundDdl,
             ];
    }

    if(field.name === "lastSalary"){
       field.options = [
             {
                   id: "undefined",
                   label: "Selecciona",
                   value: "",
                },
                ...maestrasFosfec.lastSalaryDdl,
             ];
    }

    if (field.name === "appModality") {
       field.options = [
           {
               id: "undefined",
               label: "Selecciona",
               value: "",
           },
           ...maestrasFosfec.appModalityDddl,
       ];
   }
    
      if (field.name === "laborRelationship") {
          field.options = [
              {
                  id: "undefined",
                  label: "Selecciona",
                  value: "",
              },
              ...maestrasFosfec.laborTypeDdl,
          ];
      }

      if (field.name === "independentType") {
       field.options = [
           {
               id: "undefined",
               label: "Selecciona",
               value: "",
           },
           ...maestrasFosfec.independentTypeDdl,
       ];
   }
      
      if (field.name === "idNumType") {
          field.options = [
              {
                  id: "undefined",
                  label: "Seleccionar tipo de documento",
                  value: "",
              },
              ...maestrasFosfec.docTypesDdl,
          ];
      }
      if (field.name === "department") {
          field.options = [
              {
                  id: "undefined",
                  label: "Seleccionar departamento",
                  value: "",
              },
              ...maestrasFosfec.departmentsDdl,
          ];
      }
      if (field.name === "gender") {
          field.options = [
              {
                  id: "undefined",
                  label: "Seleccionar genero",
                  value: "",
              },
              ...maestrasFosfec.genderDdl,
          ];
      }
      if (field.name === "educationLevel") {
          field.options = [
              {
                  id: "undefined",
                  label: "Seleccionar nivel de estudios",
                  value: "",
              },
              ...maestrasFosfec.educationLevelDdl,
          ];
      }

      if (field.name === "population") {
          field.options = [
              {
                  id: "undefined",
                  label: "Seleccionar poblacion",
                  value: "",
              },
              ...maestrasFosfec.populationDdl,
          ];
        }
        if (field.name === "zone") {
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar zona",
                    value: "",
                },
                ...maestrasFosfec.zonesDdl,
            ];
        }
        if (field.name === "city") {
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar ciudad",
                    value: "",
                },
                ...maestrasFosfec.citiesDdl,
            ];
        }
        if (field.name === "neighborhood") {
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar barrio",
                    value: "",
                },
                ...maestrasFosfec.neighborhoodsDdl,
            ];
        }
        if (field.name === "vulnerabilityFactor") {
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar factor de vulnerabilidad",
                    value: "",
                },
                ...maestrasFosfec.vulnerabilityFactorDdl,
            ];
        }
        if(field.name === "accountType"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar tipo de cuenta",
                    value: "",
                },
                ...maestrasFosfec.accountTypesDdl,
            ]; 
        }
        if(field.name === "ethnic"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar etnia",
                    value: "",
                },
                ...maestrasFosfec.ethnicDdl,
            ]; 
        }
        if(field.name === "laborVinculationType"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar tipo de vinculación laboral",
                    value: "",
                },
                ...maestrasFosfec.laborVinculationTypeDdl,
            ]; 
        }
        if(field.name === "healthCareProvider"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar Eps",
                    value: "",
                },
                ...maestrasFosfec.healthCareProviderDdl,
            ]; 
        }
        if(field.name === "noPensionPayed"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar motivo de no pago de pension",
                    value: "",
                },
                ...maestrasFosfec.noPensionPayedDdl,
            ]; 
        }
        if(field.name === "financialEntity"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar entidad financiera",
                    value: "",
                },
                ...maestrasFosfec.financialEntityDdl,
            ]; 
        }
        if(field.name === "afiliationLayoffsFund"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar fondo de cesantías",
                    value: "",
                },
                ...maestrasFosfec.afiliationLayoffsFundDdl,
            ]; 
        }
        if(field.name === "hasBeenMembershipedFoundCompensation"){
            field.compensationFundOptions = [
                {
                    id: "undefined",
                    label: "Seleccionar otro caja de compensación",
                    value: "",
                },
                ...maestrasFosfec.compensationFundDdl,
            ];
        }
        if(field.name === "pensionFundAfiliate"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar fondo de pensión",
                    value: "",
                },
                ...maestrasFosfec.otherCompensationFundDdl,
            ]; 
        
        }
        if(field.name === "indicateReservation"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar resguardo",
                    value: "",
                },
                ...maestrasFosfec.indicateReservationDdl,
            ];
        }
        if(field.name === "indigenousTown"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar pueblo indígena",
                    value: "",
                },
                ...maestrasFosfec.indigenousTownDdl,
            ];
        }
        if(field.name === "discapacityCondition"){
            field.options = [
                {
                    id: "undefined",
                    label: "Seleccionar condición de discapacidad",
                    value: "",
                },
                ...maestrasFosfec.discapacityConditionDdl,
            ];
        }
        
    }

    export default sectionFieldsDdlAdapter;